import { crudActions } from "./CrudActions"

export default {
  ...crudActions("tipus-exercicis"),
}
